import { DesktopNavigation } from "components/navigation"
import { useAppUI } from "providers/ui"

export const AppDesktopNavigation = () => {
  const { sideMenus, matchedPath } = useAppUI()

  return (
    <DesktopNavigation
      value={matchedPath?.to}
      bottomNavigations={sideMenus}
      navigations={sideMenus}
    />
  )
}
